import type { OrderState } from "@/model/order-state"
import { useEnsureLoaded, useHttpClient } from "@/vf"
import { defineStore } from "pinia"
import { computed, ref } from "vue"

export interface GlobalState {
    newCustomers: number
    openOrders: number
    articlesVisibleWithoutStock: number
    ordersByState: Record<OrderState, number>
    ordersByFilter: {
        ordersCompleteNotPaid: number
        ordersOpenNoCannabis: number
        expiredOrders: number
    }
    doctorQuestionnairesToReview: number
    outOfStockShowcaseArticles: number | null
    countArticleWithSoonExpiringBatches: number
    unhandledRevokedOrders: number
    unconfirmedSalesLists?: number
}

export const useGlobalState = defineStore("global-state", () => {
    const data = ref<GlobalState>()
    const { getBg } = useHttpClient()

    const u = useEnsureLoaded("global-state", async () => {
        data.value = (await getBg<GlobalState>("/global-state")).data
    })

    void u.ensureLoaded()

    setInterval(() => u.refresh(), 2 * 60 * 1000)

    return {
        data: data,
        loading: computed(() => u.state.value === "loading"),
        ensureLoaded: () => u.ensureLoaded(),
        refresh: () => u.refresh(),
    } as const
})
